<template>
  <div class="players-block">
    <div class="players-block__title">Все игроки</div>
    <div class="players-content">
      <div class="players-content__header players-list__header">
        <div class="s1">Участник</div>
        <div class="s2">Игры</div>
        <div class="s3">В составе / свободен</div>
      </div>

      <div class="players-list"
           @mouseleave="closeTooltip()"
      >
        <div class="roster"
             :style="{height: height}">
          <div v-for="item in TEAM_USERS"
               :key="item.id"
               @mouseleave="closeTooltip(true)"
          >
            <div class="roster-card"
                 :ref="'user_' + [item.id]"
            >
              <div class="card-content">
                <div class="mobile-wrapper-r">
                  <router-link :to="{name: 'another-profile', params: {id: item.id}}" target="_blank" class="info">
                    <div class="ava">
                      <img :src="`${item.attributes.logo}`" alt="">
                    </div>
                    <div class="text">
                      <div class="top">
                        <country-flag :country="item.attributes.country" rounded size="normal"/>
                        <div class="nickname">{{ item.attributes.login }}</div>
                      </div>
                      <div class="name">{{ item.attributes.firstName !== null ? item.attributes.firstName : '' }}
                        {{ item.attributes.lastName !== null ? item.attributes.lastName : '' }}
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="mobile-wrapper-l">
                  {{ isPlayerInCopmposition(item) ? 'В составе' : '' }}
                </div>
                <div class="games__wrap">
                  <div class="games">
                    <img v-for="(game, i) in item.games"
                         :key="game.id"
                         :src="game.logo"
                         :style="getGameImgTranslate(i)"
                         alt=""
                    >
                  </div>
                </div>
              </div>
              <div class="gear"
                   @mouseenter="getGearCoordinates($event); setCurrentHoveredUser(item)"
                   v-if="isUserCanEditComposition"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
                      stroke="#E2FF31" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M16.1673 12.4997C16.0564 12.751 16.0233 13.0298 16.0723 13.3002C16.1213 13.5705 16.2502 13.8199 16.4423 14.0163L16.4923 14.0663C16.6473 14.2211 16.7702 14.4049 16.8541 14.6073C16.938 14.8096 16.9811 15.0265 16.9811 15.2455C16.9811 15.4645 16.938 15.6814 16.8541 15.8837C16.7702 16.0861 16.6473 16.2699 16.4923 16.4247C16.3375 16.5796 16.1537 16.7026 15.9514 16.7864C15.7491 16.8703 15.5322 16.9135 15.3131 16.9135C15.0941 16.9135 14.8772 16.8703 14.6749 16.7864C14.4726 16.7026 14.2888 16.5796 14.134 16.4247L14.084 16.3747C13.8876 16.1826 13.6381 16.0537 13.3678 16.0047C13.0975 15.9557 12.8187 15.9887 12.5673 16.0997C12.3208 16.2053 12.1106 16.3807 11.9626 16.6043C11.8145 16.8279 11.7351 17.0899 11.734 17.358V17.4997C11.734 17.9417 11.5584 18.3656 11.2458 18.6782C10.9333 18.9907 10.5093 19.1663 10.0673 19.1663C9.62529 19.1663 9.20137 18.9907 8.88881 18.6782C8.57625 18.3656 8.40065 17.9417 8.40065 17.4997V17.4247C8.3942 17.1488 8.30492 16.8813 8.14441 16.6569C7.9839 16.4325 7.7596 16.2616 7.50065 16.1663C7.2493 16.0554 6.97049 16.0223 6.70016 16.0713C6.42983 16.1204 6.18038 16.2492 5.98398 16.4413L5.93398 16.4913C5.7792 16.6463 5.59538 16.7692 5.39305 16.8531C5.19072 16.937 4.97384 16.9802 4.75482 16.9802C4.53579 16.9802 4.31891 16.937 4.11658 16.8531C3.91425 16.7692 3.73044 16.6463 3.57565 16.4913C3.42069 16.3366 3.29776 16.1527 3.21388 15.9504C3.13001 15.7481 3.08684 15.5312 3.08684 15.3122C3.08684 15.0931 3.13001 14.8763 3.21388 14.6739C3.29776 14.4716 3.42069 14.2878 3.57565 14.133L3.62565 14.083C3.81776 13.8866 3.94664 13.6372 3.99565 13.3668C4.04467 13.0965 4.01158 12.8177 3.90065 12.5663C3.79501 12.3199 3.61961 12.1097 3.39604 11.9616C3.17246 11.8135 2.91047 11.7341 2.64232 11.733H2.50065C2.05862 11.733 1.6347 11.5574 1.32214 11.2449C1.00958 10.9323 0.833984 10.5084 0.833984 10.0663C0.833984 9.62431 1.00958 9.20039 1.32214 8.88783C1.6347 8.57527 2.05862 8.39967 2.50065 8.39967H2.57565C2.85148 8.39322 3.11899 8.30394 3.3434 8.14343C3.56781 7.98293 3.73875 7.75862 3.83398 7.49967C3.94491 7.24833 3.978 6.96951 3.92899 6.69918C3.87997 6.42885 3.7511 6.17941 3.55898 5.98301L3.50898 5.93301C3.35402 5.77822 3.23109 5.5944 3.14722 5.39207C3.06334 5.18974 3.02017 4.97287 3.02017 4.75384C3.02017 4.53481 3.06334 4.31794 3.14722 4.11561C3.23109 3.91328 3.35402 3.72946 3.50898 3.57467C3.66377 3.41971 3.84759 3.29678 4.04992 3.21291C4.25225 3.12903 4.46912 3.08586 4.68815 3.08586C4.90718 3.08586 5.12405 3.12903 5.32638 3.21291C5.52871 3.29678 5.71253 3.41971 5.86732 3.57467L5.91732 3.62467C6.11372 3.81679 6.36316 3.94566 6.63349 3.99468C6.90382 4.04369 7.18264 4.0106 7.43398 3.89967H7.50065C7.74712 3.79404 7.95733 3.61864 8.10539 3.39506C8.25346 3.17149 8.33291 2.9095 8.33398 2.64134V2.49967C8.33398 2.05765 8.50958 1.63372 8.82214 1.32116C9.1347 1.0086 9.55862 0.833008 10.0007 0.833008C10.4427 0.833008 10.8666 1.0086 11.1792 1.32116C11.4917 1.63372 11.6673 2.05765 11.6673 2.49967V2.57467C11.6684 2.84283 11.7478 3.10482 11.8959 3.3284C12.044 3.55197 12.2542 3.72737 12.5006 3.83301C12.752 3.94394 13.0308 3.97703 13.3011 3.92801C13.5715 3.879 13.8209 3.75012 14.0173 3.55801L14.0673 3.50801C14.2221 3.35305 14.4059 3.23012 14.6082 3.14624C14.8106 3.06237 15.0275 3.0192 15.2465 3.0192C15.4655 3.0192 15.6824 3.06237 15.8847 3.14624C16.087 3.23012 16.2709 3.35305 16.4256 3.50801C16.5806 3.6628 16.7035 3.84661 16.7874 4.04894C16.8713 4.25127 16.9145 4.46815 16.9145 4.68717C16.9145 4.9062 16.8713 5.12308 16.7874 5.32541C16.7035 5.52774 16.5806 5.71155 16.4256 5.86634L16.3756 5.91634C16.1835 6.11274 16.0547 6.36219 16.0056 6.63252C15.9566 6.90285 15.9897 7.18166 16.1006 7.43301V7.49967C16.2063 7.74615 16.3817 7.95635 16.6053 8.10442C16.8288 8.25248 17.0908 8.33194 17.359 8.33301H17.5006C17.9427 8.33301 18.3666 8.5086 18.6792 8.82116C18.9917 9.13372 19.1673 9.55765 19.1673 9.99967C19.1673 10.4417 18.9917 10.8656 18.6792 11.1782C18.3666 11.4907 17.9427 11.6663 17.5006 11.6663H17.4256C17.1575 11.6674 16.8955 11.7469 16.6719 11.8949C16.4484 12.043 16.273 12.2532 16.1673 12.4997V12.4997Z"
                      stroke="#E2FF31" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
        </div>

        <Tooltip
            v-if="isTooltip"
            :position="tooltipPosition"
        >
          <template v-slot:tooltip-menu>
            <div class="menu tooltip-items"
                 @mouseenter="showTooltipAnyway()"
                 @mouseleave="closeTooltip()"
            >
              <div class="tooltip-item"
                   v-if="!isPlayerInCopmposition(hoveredUser)"
                   @click="updateComposition(hoveredUser, 'new_user')"
              >Добавить в состав</div>

              <template v-if="MANAGER_POV">
                <div class="tooltip-item"
                     v-if="hoveredUser.id !== USER.id"
                     @click="confirmDelete(hoveredUser.id)"
                >Удалить из команды</div>
              </template>
            </div>
          </template>
        </Tooltip>
      </div>
    </div>

    <confirmation-modal
        v-if="isConfirmModal"
        accept-button-text="Удалить"
        decline-button-text="Оставить"
        :header-text="confirmText"
        :success-call-back="successCallBack"
        @decline="isConfirmModal = false"
        @closeModal="isConfirmModal = false"
    />
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import CountryFlag from 'vue-country-flag'
import ConfirmationModal from "@/components/modals/confirmation-modal";
import {compositionMixin} from "@/otherJS/mixins/team-compositions-mixin";
import Tooltip from "@/components/UIElements/Tooltip/Tooltip";

export default {
  name: "team-players-list",
  components: {Tooltip, ConfirmationModal, CountryFlag},
  mixins: [compositionMixin],
  props: {
    height: {type: String, required: true}
  },
  data() {
    return {
      confirmText: '',
      isConfirmModal: false,
      userToDelete: null,
      successCallBack: null,

      tooltipPosition: [],
      isTooltip: false,
      tooltipDisappearTimer: null,
      hoveredUser: {}
    }
  },
  computed: {
    ...mapGetters([
      'USER',
      'TEAM_USERS',
      'MANAGER_POV',
      'TEAM',
      'TEAM_GAMES',
      'ACTIVE_TEAM_TAB',
      'USER'
    ]),
    getRosterHeight() {
      return this.$refs.compositionList
    }
  },
  watch: {
    isTooltip: function (nV, oV){
      if (nV === false) {
        /* Важно выполнять этот метод раньше, чем очистку this.hoveredUser,
        * т.к. в этом методе используется this.hoveredUser.id
        * */
        this.manipulationHoverClassToUserCard(false);
        this.setCurrentHoveredUser({});
      }
    }
  },
  methods: {
    ...mapActions([
      'DELETE_USER_FROM_TEAM',
      'CHANGE_DISCIPLINE_COMPOSITION'
    ]),
    getGameImgTranslate(i) {
      return `transform: translateX(-${14 * i}px); z-index: ${i}`
    },
    showConfirm() {
      this.isConfirmModal = true;
    },

    confirmDelete(user_id) {
      this.userToDelete = user_id;
      this.confirmText = 'Вы действительно хотите удалить этого игрока?'
      this.showConfirm();
      this.successCallBack = this.deleteUser;
    },
    deleteUser() {
      let data = {
        team_id: this.TEAM.id,
        user_id: this.userToDelete
      }

      this.DELETE_USER_FROM_TEAM(data)
    },

    showMessage() {
      alert('Все слоты дисциплины заполнены')
    },

    /**
     * Собираем координаты шестерёнки на странице, записываем их и открываем тултип
     * */
    getGearCoordinates(evt) {
      const coords = evt.target.getBoundingClientRect(),
          scrollTop = window.pageYOffset || document.documentElement.scrollTop,
          top = coords.top + scrollTop,
          left = coords.left;

      this.tooltipPosition = [left - 160, top - 35];
      if (window.innerWidth < 769) {
        this.tooltipPosition = [left - 160, top];
      }

      this.isTooltip = true;
    },

    /**
     * Закрываем тултип.
     * Если мы ушли с карточки участника, то ждем 200мс, вдруг мы все таки на тултипе, если да,
     * то сбрасываем таймер в функции 'showTooltipAnyway'
     * */
    closeTooltip(defer = false) {
      if (!defer) {
        this.isTooltip = false;
        this.tooltipPosition = [];

        return;
      }

      this.tooltipDisappearTimer = setTimeout(() => {
        this.isTooltip = false;
        this.tooltipPosition = [];
      }, 200)

      if (window.innerWidth < 769) {
        this.showTooltipAnyway();
      }
    },

    /**
     * Очищаем таймер, что бы тултип не пропал, при анховере карточки игрока.
     * */
    showTooltipAnyway() {
      clearTimeout(this.tooltipDisappearTimer);
    },

    /**
     * Записываем в this.hoveredUser данные о участнике, на котором открыли тултип
     *
     * @param user - объект участника
     * */
    setCurrentHoveredUser(user) {
      this.hoveredUser = user;

      if (user.id && window.innerWidth > 768) {
        this.manipulationHoverClassToUserCard();
      }
    },

    /**
     * Управляем ховер классом для карточки игрока, что бы она была активной, при курсоре на тултипе.
     *
     * @param add - отвечает за добавление или удаление класса.
     * */
    manipulationHoverClassToUserCard(add = true) {
      if (!add) {
        this.$refs[`user_${this.hoveredUser.id}`][0].classList.remove('hovered');
        return;
      }

      this.$refs[`user_${this.hoveredUser.id}`][0].classList.add('hovered');
    }
  }
}
</script>

<style lang="scss" scoped>
.team-profile-players .roster-card .mobile-wrapper-l {
  @media (max-width: 768px) {
    transform: translateY(-8px);
  }
}
</style>